/**
 * Which patient chart was last open in Patient Details.
 *
 * Session-scoped on purpose: it should follow this sitting, not persist across
 * a new sign-in. Every access is wrapped because private windows and browsers
 * set to block site data throw on `sessionStorage` rather than returning null —
 * remembering is a convenience, so a failure here must never break navigation.
 *
 * Shared between `Searchbar` (which writes it) and `Doctor-Sidebar` (which
 * clears it, so the Patient Details menu entry always lands on the list).
 */

const LAST_PATIENT_KEY = 'youro:lastViewedPatientId';

export const getLastViewedPatient = () => {
  try {
    return sessionStorage.getItem(LAST_PATIENT_KEY);
  } catch (e) {
    return null;
  }
};

export const setLastViewedPatient = (patientId) => {
  try {
    sessionStorage.setItem(LAST_PATIENT_KEY, patientId);
  } catch (e) {
    // ignore
  }
};

export const clearLastViewedPatient = () => {
  try {
    sessionStorage.removeItem(LAST_PATIENT_KEY);
  } catch (e) {
    // ignore
  }
};
